var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"message-detail"},[_c('pre',[_vm._v("    "+_vm._s(_vm.content)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }